import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const ChevronRight = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 15 15" {...props}>
    <path d="M4.48324 15L11.9832 7.5L4.48324 0L3.375 1.125L9.75 7.5L3.375 13.875L4.48324 15Z" />
  </SvgIcon>
);
